import routes from '@/routes.js';
import { matchRoutes } from 'react-router-dom';

let cachedPathname = null;
let cachedMatch = null;

const EMPTY_PARAMS = Object.freeze({});

const getPieveRouteMatch = (pathname = '') => {
  const normalizedPathname = String(pathname || '').trim() || '/';

  if (cachedPathname === normalizedPathname && cachedMatch) {
    return cachedMatch;
  }

  const matches = matchRoutes(routes, normalizedPathname) || [];
  const lastMatch = matches.length > 0 ? matches[matches.length - 1] : null;
  const nextMatch = {
    route: lastMatch?.route || null,
    params: lastMatch?.params && typeof lastMatch.params === 'object' && !Array.isArray(lastMatch.params) ? lastMatch.params : EMPTY_PARAMS
  };

  cachedPathname = normalizedPathname;
  cachedMatch = nextMatch;

  return nextMatch;
};

export default getPieveRouteMatch;
